import { useQuery } from '@tanstack/react-query';

import { KimLhcService } from '@/infra/services/kim-lhc';
import { QUERY_KEYS } from '@/utils/query-keys';

import type { KimLhcResult } from '@/types';

interface GetKimLhcResultParams {
	id: string;
	organization_id: string;
	company_id: string;
}

const Service = KimLhcService.getInstance();

export const useGetKimLhcResult = (params: GetKimLhcResultParams) => {
	return useQuery<KimLhcResult>({
		queryKey: [QUERY_KEYS.GET_KIM_LHC_RESULT, params.id],
		queryFn: async () => Service.getResult(params),
		enabled: !!params.id && !!params.organization_id && !!params.company_id
	});
};
